export const SIGN_IN = '/';
export const SIGN_UP = '/signup';
export const CALENDAR = '/calendar';
export const ACCOUNT = '/account';
export const PASSWORD_RESET = '/pw-reset';
export const CONTACTS = '/contacts';
export const SETTLEMENTS = '/settlements';
export const ADMIN = '/admin';
export const ADMIN_DETAILS = '/admin/:id';